import React, { createContext, useState, useEffect } from "react";
//import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // token loads immediately from localStorage
    const [token, setToken] = useState(() => localStorage.getItem("token"));
    const [userName, setUserName] = useState(() => localStorage.getItem("userName"));
    const [corporateId, setCorporateId] = useState(() => localStorage.getItem("agencyId"));
    const [name, setName] = useState(() => localStorage.getItem("name"));
    const [roles, setRole] = useState(() => localStorage.getItem("roles"));

    // const login = (newToken) => {
    //     localStorage.setItem("token", newToken);  // 1. Browser storage
    //     setToken(newToken);                       // 2. React Context state
    // };

    const login = (newToken, userName, agencyId, name, roles) => {
        localStorage.setItem("token", newToken);  // 1. Browser storage
        localStorage.setItem("userName", userName);
        localStorage.setItem("agencyId", agencyId);
        localStorage.setItem("name", name);
        localStorage.setItem("roles", roles);

        setToken(newToken);  // 2. React Context state
        setUserName(userName);
        setCorporateId(agencyId);
        setName(name);
        setRole(roles);
    };



    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userName");
        localStorage.removeItem("agencyId");
        localStorage.removeItem("name");
        localStorage.removeItem("roles");

       setToken(null);
        setUserName(null);
        setCorporateId(null);
        setName(null);
        setRole(null);
        //navigate("/login", { replace: true }); //  Prevent back navigation
    };

    return (
        <AuthContext.Provider value={{ token, userName, corporateId, name, roles, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
